import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold mb-4" }, "Zugangsdaten", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Neue Zugangsdaten ")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-primary" }, [
  /*#__PURE__*/_createTextVNode(" Sie haben einen Email erhalten."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bitte bestätigen Sie den Link in Ihrer Email."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sollten Sie keine Mobilnummer hinterlegt haben, so erhalten Sie eine zweite Mail mit dem Bestätigungspin ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-lg-12" }
const _hoisted_13 = {
  key: 0,
  class: "form-group form-group-feedback form-group-feedback-left"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-muted" })
], -1)
const _hoisted_15 = { class: "card-footer text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_ctx.resetSuccess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (!_ctx.resetSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "text",
                        tabindex: "1",
                        placeholder: "Emailadresse",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.email.value) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.frm.email.value]
                      ]),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args))),
              tabindex: "3"
            }, _toDisplayString(_ctx.resetSuccess?'Link erneut versenden':'Passwort zurücksetzen'), 1)
          ])
        ])
      ])
    ])
  ]))
}